<template>
    <header
      id="site-header"
      class="site-header"
      :class="[{ open: isOpen }, { 'open-mega': isMegaOpen }]"
    >
      <div class="top">
        <div class="content-max-width flex">
          <a href="/home" class="logo">
            <img src="/images/logo-dark.svg" alt="Habit Health logo" />
          </a>

          <div class="right-links">
            <ul>
              <li v-for="(item, index) of top_links"
                :key="index">
                <a :href="item.url" :target="item.is_external ? '_blank' : '_self'">{{ item.title }}<img v-if="item.children.length" src="/images/top-dropdown.svg" alt=""></a>
                <div v-if="item.children.length" class="dropdown">
                  <a v-for="(child, i) of item.children" :href="child.url" :target="child.is_external ? '_blank' : '_self'" :key="i">{{ child.title }}</a>
                </div>
              </li>
            </ul>
          </div>

          <div class="top-search">
            <img src="/images/search-dark.svg" alt="Search" @click="toggleDesktopSearch">

            <div v-if="isDesktopSearchOpen" class="search-open">
              <img src="/images/search-dark.svg" alt="Search" class="search">

              <input type="text"
                v-on:keyup.enter="enterSearch"
                v-model="search"
              >

              <div @click="toggleDesktopSearch">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="#FFFFFF" class="close" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <button class="search-mob" @click="openSearch">
        <img src="/images/search-dark.svg" alt="Habit Health Search" />
      </button> -->

      <button class="hamburger mobile" @click="toggleMenu">
        <span></span><span></span><span></span>
      </button>

      <HeaderSearch
        :groups="groups"
        :module_type="module_type"
        :search_url="search_url"
        :popular_searches="popular_searches"
        :all_services="all_services"
        v-if="isSearchOpen"
        v-on:close="closeSearch"
      ></HeaderSearch>

      <div class="buttons">
        <a href="/log-in" class="button-login">Log in</a>
        <a href="/book-now" class="button-book">Book Now</a>
      </div>

      <div class="mobile-menu">
        <div class="header">
          <a href="" class="logo">
            <img src="/images/logo.png" alt="">
          </a>
          <div class="close" @click="toggleMenu">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#313232" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </div>
        </div>
        <div class="menu-buttons">
          <a href="/log-in" class="button-login">Log in</a>
          <a href="/book-now" class="button-book">Book Now</a>
        </div>
        <div class="body">
          <div class="links">
            <Collapsible
              v-for="link in links"
              :key="link.id"
              class="link"
            >
              <template #trigger="{ isOpen, toggle }">
                <h4 @click="toggle">{{ link.title }}</h4>
                <p @click="toggle">{{ link.alt_text }}</p>
              </template>

              <template #collapsible="{ isOpen, close }">
                <div v-show="isOpen" class="link-child">
                  <div class="child-header flex flex-wrap">
                    <img src="/images/icons/return-to-top-dark.svg" alt="Back" @click="close">
                    <div class="flex-1">
                      <h4>{{ link.title }}</h4>
                      <p>{{ link.alt_text }}</p>
                    </div>
                  </div>
                  <Collapsible
                    v-for="childLink in link.children"
                    :key="childLink.id"
                    class="link-collapsible"
                  >
                    <template #trigger="{ isOpen, toggle }">
                      <div class="collapsible-header" @click="toggle">
                        <div class="flex-1">
                          <h4>{{ childLink.title }}</h4>
                          <p>{{ childLink.alt_text }}</p>
                        </div>
                        <svg v-show="isOpen" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#657781" class="bi bi-dash-lg" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"/>
                        </svg>
                        <svg v-show="! isOpen" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#657781" class="bi bi-plus-lg" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                        </svg>
                      </div>
                    </template>

                    <template #collapsible="{ isOpen }">
                      <div v-show="isOpen" class="collapsible-body">
                        <a
                          v-for="grandChildLink in childLink.children"
                          :key="grandChildLink.id"
                          :href="grandChildLink.url"
                        >{{grandChildLink.title}}</a>
                      </div>
                    </template>
                  </Collapsible>
                  <!-- <div class="link-collapsible">
                    <div class="collapsible-header">
                      <div class="flex-1">
                        <h4>Personal Fitness</h4>
                        <p>Te Whakapakari Tinana</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg"width="24" height="24" fill="#657781" class="bi bi-plus-lg" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                      </svg>
                    </div>
                    <div class="collapsible-body">
                      <a href="">Memberships</a>
                      <a href="">Timetables</a>
                    </div>
                  </div> -->
                </div>
              </template>

            </Collapsible>
            <a :href="item.url" class="link" v-for="(item, index) of top_links" :key="index">
              <h4>{{ item.title }}</h4>
            </a>
          </div>
        </div>
      </div>
    </header>
  </template>

  <script>
  import HeaderSearch from './HeaderSearch.vue'
  import HeaderMegaMenu from './HeaderMegaMenu.vue'
  import Slick from 'vue-slick'
  import Collapsible from './Collapsible.vue'

  export default {
    components: {
      HeaderSearch,
      HeaderMegaMenu,
      Slick,
      Collapsible,
    },

    props: {
      groups: Array,
      module_type: Array,
      search_url: String,
      popular_searches: Array,
      all_services: Array,
      top_links: Array,
      links: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        hover: false,
        isOpen: false,
        isSearchOpen: false,
        isMegaOpen: false,
        subOpen: false,
        isImageStyle: false,
        active_id: null,
        menu: [],
        bottom_menu: [],
        mega_menu: [],
        isDesktopSearchOpen: false,
        search: ''
      };
    },
    mounted() {
      // this.menu = this.links.filter((obj) => obj.title !== "Pages");

      // if (
      //   ~window.location.href.indexOf("personal") ||
      //   ~window.location.href.indexOf("")
      // ) {
      //   this.bottom_menu = this.links.find((obj) => obj.title === "Personal");
      // }
      // if (~window.location.href.indexOf("acc-programmes")) {
      //   this.bottom_menu = this.links.find(
      //     (obj) => obj.title === "ACC Programmes"
      //   );
      // }
      // if (~window.location.href.indexOf("workplace")) {
      //   this.bottom_menu = this.links.find((obj) => obj.title === "Workplace");
      // }



      // // hardcode chldren into 'Personal Fitness'. BE to remove when ready
      // let child = [
      //   { title: 'Timetables', url: '/personal/personal-fitness/timetables', image: '/images/personal-fitness-timetables.jpg' },
      //   { title: 'Memberships', url: '/personal/personal-fitness/timetables', image: '/images/personal-fitness-timetables.jpg' },
      //   { title: 'Personal training', url: '/personal/personal-fitness/timetables', image: '/images/personal-fitness-timetables.jpg' },
      //   { title: 'Group Fitness', url: '/personal/personal-fitness/timetables', image: '/images/personal-fitness-timetables.jpg' },
      //   { title: 'Fitness Club Locations', url: '/personal/personal-fitness/timetables', image: '/images/personal-fitness-timetables.jpg' },
      //   { title: 'View all', url: '/personal/personal-fitness', image: '/images/personal-fitness-timetables.jpg' },
      // ]
      // let menu_ti = 'Laudem et rationibus confirmare'

      // this.bottom_menu.children[0].children = child
      // this.bottom_menu.children[0].menu_title = menu_ti

      // // hardcode chldren into 'Personal Fitness'. BE to remove when ready
      // let child2 = [
      //   { title: 'Housing Assessments', url: '/personal/personal-fitness/timetables' },
      //   { title: 'Rehabilitation at Home', url: '/personal/personal-fitness/timetables' },
      //   { title: 'Best Wheelchair For You', url: '/personal/personal-fitness/timetables' },
      //   { title: 'Vehicle Assessment', url: '/personal/personal-fitness/timetables' },
      //   { title: 'Carer Training', url: '/personal/personal-fitness/timetables' },
      //   { title: 'Speech Language Therapy for Adults', url: '/personal/personal-fitness/timetables' }
      // ]
      // let menu_ti2 = 'Laudem et rationibus confirmare'
      // let menu_de2 = 'Semper eget duis at tellus convallis a cras semper auctor?'

      // this.bottom_menu.children[1].children = child2
      // this.bottom_menu.children[1].menu_title = menu_ti2
      // this.bottom_menu.children[1].menu_description = menu_de2
    },

    methods: {
      toggleDesktopSearch() {
        this.isDesktopSearchOpen = !this.isDesktopSearchOpen;
      },

      toggleMenu() {
        this.isOpen = !this.isOpen;
        this.$parent.$emit("emitMenuToggle", this.isOpen);
      },

      toggleSubMenu(index) {
        this.hover = true;
        console.log(index, "true");
        if (this.active_id === index) {
          this.active_id = null;
        } else {
          this.active_id = index;
        }
      },

      // toggleMega (link) {
      //   if (link !== null) {
      //     if (link.children.length) {
      //       this.isMegaOpen = true;
      //       this.subOpen = true;
      //       this.mega_menu = link;

      //         if (link.template === "Thumbnails") {
      //             this.isImageStyle = true;
      //         }
      //         else {
      //             this.isImageStyle = false;
      //         }
      //     }
      //   }
      //   // console.log(link)
      // },

      // openLink (link) {
      //   if (link.children.length) {
      //     this.toggleMega(link)
      //   } else {
      //     window.location.href = link.url;
      //   }
      // },

      openSearch() {
        this.isSearchOpen = !this.isSearchOpen;
        this.$parent.$emit("emitMenuToggle", this.isSearchOpen);
      },

      closeSearch() {
        this.isSearchOpen = false;
        this.$parent.$emit("emitMenuToggle", this.isSearchOpen);
      },

      enterSearch() {
        if(this.search.length) {
          location.href = '/search/results?keyword='+this.search
        }
      }
    },
  };
  </script>

  <style scoped>
  .megamenu p {
    max-width: 570px;
    margin: 0 0 40px;

    font-size: 15px;
    letter-spacing: 0;
    line-height: 24px;
    color: #657781;
    white-space: break-spaces;
  }
  </style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue